import { useContextState } from '../../../../../hooks/theme'

export const useStyles = () => {
  const { colors } = useContextState()

  return {
    content: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      gap: '18px',
      overflowY: 'auto',
      minHeight: 0,
    },
    sectionTitle: {
      fontSize: '16px',
      fontWeight: '600',
      color: colors.color13,
    },
    sectionSubtitle: {
      fontSize: '14px',
      color: colors.color10,
    },
    helperText: {
      fontSize: '13px',
      color: colors.color28,
      fontStyle: 'italic',
    },
    fullWidth: {
      width: '100%',
      alignItems: 'flex-end',
    },
    instructionsField: {
      marginTop: '16px',
    },
    toggleContainer: {
      display: 'flex',
      alignItems: 'center',
      marginTop: '16px',
      padding: '12px 16px',
      border: `1px solid rgba(0, 0, 0, 0.23)`,
      borderRadius: '4px',
    },
    toggleLabel: {
      fontSize: '14px',
      color: colors.color13,
      fontWeight: '600',
    },
    whatIncludesSection: {
      marginTop: '16px',
    },
    card: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: '8px',
      padding: '5px 9px',
      border: `1px solid rgba(0, 0, 0, 0.23)`,
      borderRadius: '4px',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      backgroundColor: colors.color5,
    },
    cardContent: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      minWidth: 0,
    },
    cardTitle: {
      fontSize: '14px',
      fontWeight: '600',
      color: colors.color13,
    },
    cardDescription: {
      fontSize: '13px',
      color: colors.color10,
      lineHeight: 1.4,
    },
    cardArrow: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: colors.color10,
      fontSize: '20px',
      fontWeight: '600',
    },
    cardActions: {
      display: 'flex',
      alignItems: 'center',
      gap: '6px',
    },
    checkIcon: {
      display: 'flex',
      alignItems: 'center',
      '& .MuiSvgIcon-root': {
        fontSize: '24px',
        color: colors.color8,
      },
    },
    deleteIcon: {
      display: 'flex',
      alignItems: 'center',
      color: colors.color19,
      fontSize: '24px',
      cursor: 'pointer',
    },
  }
}
